import { addMonths, endOfMonth, startOfMonth } from 'date-fns';
import { useState } from 'react';
import type { Period } from 'components/shared/DateNavigation';

export const usePeriodAndDateState = () => {
  'use memo';

  const [period, setPeriod] = useState<Period>('custom');
  const [selectedDate, setSelectedDate] = useState<Date | null>(
    () => new Date()
  );
  const [selectedDateRange, setSelectedDateRange] = useState<
    [Date | null, Date | null]
  >(() => [
    startOfMonth(addMonths(new Date(), -2)),
    endOfMonth(addMonths(new Date(), 1))
  ]);

  return {
    period,
    setPeriod,
    selectedDate,
    setSelectedDate,
    selectedDateRange,
    setSelectedDateRange
  };
};
